var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBdIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6C4 3.79086 5.79086 2 8 2H12H14.0633C14.6568 2 15.2197 2.26365 15.5997 2.71963L19.5364 7.44373C19.836 7.80316 20 8.25623 20 8.7241V12V18C20 20.2091 18.2091 22 16 22H8C5.79086 22 4 20.2091 4 18V6Z",
    stroke: "#1A202B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5V6C15 7.10457 15.8954 8 17 8H19.5",
    stroke: "#1A202B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H16",
    stroke: "#1A202B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H12",
    stroke: "#1A202B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78049 7.2782C9.78049 6.89939 9.43293 6.59527 9 6.59527C8.57317 6.59527 8.21951 6.89939 8.21951 7.2782C8.21951 7.65701 8.56707 7.96113 9 7.96113C10.1037 7.96113 11 8.74543 11 9.71113C11 10.4901 10.4146 11.141 9.60976 11.3704V11.4665C9.60976 11.7599 9.33537 12 9 12C8.66463 12 8.39024 11.7599 8.39024 11.4665V11.3704C7.58537 11.141 7 10.4901 7 9.71113C7 9.41768 7.27439 9.17759 7.60976 9.17759C7.94512 9.17759 8.21951 9.41768 8.21951 9.71113C8.21951 10.0899 8.56707 10.3941 9 10.3941C9.43293 10.3941 9.78049 10.0899 9.78049 9.71113C9.78049 9.33232 9.43293 9.0282 9 9.0282C7.89634 9.0282 7 8.2439 7 7.2782C7 6.49924 7.58537 5.84832 8.39024 5.6189V5.53354C8.39024 5.24009 8.66463 5 9 5C9.33537 5 9.60976 5.24009 9.60976 5.53354V5.6189C10.4146 5.84832 11 6.49924 11 7.2782C11 7.57165 10.7256 7.81174 10.3902 7.81174C10.0549 7.81174 9.78049 7.57165 9.78049 7.2782Z",
    fill: "#1A202B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBdIcon);
export default __webpack_public_path__ + "static/media/BDIcon.3e6b851ddabb5d1cd7db76274113d475.svg";
export { ForwardRef as ReactComponent };